import { FC } from "react";
import { SessionContextMention } from "@/mds/components/sessions/session.types";
import { MDSSessionConfig } from "@/mds/components/sessions/session.types";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { getDisplayText, getIconKind, getId } from "./session-context-item.utils";
import {
  StyledContextIcon,
  StyledContextItem,
  StyledContextText,
} from "./session-context-item.styles";
import { MDSIcon, MDSIconColor } from "@/mds/components/icon";

interface Props {
  mention: SessionContextMention;
  config: MDSSessionConfig;
}

export const MDSSessionContextItem: FC<Props> = ({ mention, config }) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!config.linkHandler) return;

    const mentionKind =
      mention.kind === "NOTE" ? MemCommonMentionKind.Note : MemCommonMentionKind.Collection;

    config.linkHandler(mentionKind, getId({ mention }), event.currentTarget, event);
  };

  return (
    <StyledContextItem onClick={handleClick} role="button" tabIndex={0}>
      <StyledContextIcon>
        <MDSIcon kind={getIconKind({ mention })} size={12} color={MDSIconColor.Secondary} />
      </StyledContextIcon>
      <StyledContextText>{getDisplayText({ mention })}</StyledContextText>
    </StyledContextItem>
  );
};
